import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router';
import { validate as isUuid } from 'uuid';
import { ALPHA_ID_PREFIXES, isValidAlphaID } from '@theguarantors/tg-modern-business';

import { routes } from '@/constants/Constants';
import useABTestStore from '@/stores/abTestStore';
import { useAnalyticsContext } from '@/shared/providers/analytics';
import { cachedSessionStorage } from '@/utils/cachedSessionStorage';
import { PrivateRoutes } from './PrivateRoutes';
import { PublicRoutes } from './PublicRoutes';

export const RouteEffects = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const { page, isReady } = useAnalyticsContext();
  const { loaded: experimentsLoaded } = useABTestStore();
  useABTestStore.getState().useFetchABTestsValues();

  useEffect(() => {
    cachedSessionStorage.cacheStorage();
    cachedSessionStorage.storeUTM(searchParams);
  }, [searchParams]);

  useEffect(() => {
    if (!isReady || !experimentsLoaded) return;

    window.scrollTo({ top: 0, behavior: 'instant' });
    if (!location.pathname || location.pathname === routes.home) return;

    page(location.pathname + location.hash);

    const matchedRoute = [...PublicRoutes, ...PrivateRoutes].find((route) => {
      if (route.path === location.pathname) return true;

      if (route.path === routes.userDetails) {
        return isUuid(location.pathname.split('/')[2]);
      }

      if (route.path === routes.claimsSubmissionDetails) {
        const segments = location.pathname.split('/');
        return (
          isValidAlphaID(ALPHA_ID_PREFIXES.CLAIM, segments[2]) &&
          isValidAlphaID(ALPHA_ID_PREFIXES.CLAIM_SUBMISSION, segments[4])
        );
      }

      return false;
    });

    if (matchedRoute?.title && document.title !== matchedRoute.title) {
      document.title = matchedRoute.title;
    }
  }, [experimentsLoaded, isReady, location.hash, location.pathname, page]);

  return null;
};
